module.exports = __webpack_public_path__ + "static/media/hipercard.23439a94.svg";